<ng-container *ngIf="vm$ | async as state">
  <div class="container py-0-5">
    <!-- Logo Section -->
    <a *ngIf="state.showNavItems; else logoOnly" [routerLink]="state.rootLink" (click)="onLogoClick()">
      <img [src]="logoSrc" alt="WTax" class="logo" />
    </a>
    <ng-template #logoOnly>
      <img [src]="logoSrc" alt="WTax" class="logo" />
    </ng-template>

    <!-- Account Selection -->
    <app-account-dropdown
      #accountDropdown
      *ngIf="state.isFundOrWealthManager && state.showNavItems"
      (accountSelectedEvent)="accountSelected($event)"
    ></app-account-dropdown>

    <!-- Navigation Menu -->
    <nav class="navigation" [class.disabled]="state.accountCreationInProgress" *ngIf="state.showNavItems">
      <app-navigation-item
        *ngFor="let item of state.items"
        class="navigation-item"
        [menuItem]="item"
        [disabled]="state.accountCreationInProgress"
      ></app-navigation-item>
    </nav>

    <!-- Profile & User Menu -->
    <div #profile class="profile" [class.active]="state.profileVisible" [class.push-right]="!state.showNavItems">
      <svg-icon [key]="loginIconKey" [class.new-login-icon]="isNewLoginIcon"></svg-icon>

      <ul class="profile-menu" [class.visible]="state.profileVisible">
        <li *ngIf="state.hasAccountSettings && !state.isCustodian && state.showNavItems" [class.disabled]="state.accountCreationInProgress">
          <a [routerLink]="!state.accountCreationInProgress ? myAccountLink : undefined">
            {{ 'HEADER.MY_ACCOUNT' | translate }}
          </a>
        </li>
        <li>
          <span (click)="onLogoutClick()">{{ 'HEADER.LOGOUT' | translate }}</span>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
